export const MIN_PROVIDER_TYPES = 1;
export const MAX_PROVIDER_TYPES = 5;

export function mapProviderTypeOption(item = {}) {
  return {
    id: item?.id ?? item?.key ?? null,
    label: item?.label ?? item?.name ?? item?.value ?? item?.type ?? "",
  };
}

export function getInitialPrimaryFormState(providerInformation = {}) {
  return {
    providerTypes: (providerInformation?.provider_types ?? providerInformation?.providerTypes ?? [])
      .map(mapProviderTypeOption)
      .filter((item) => item.id !== null && item.label),
    email: providerInformation?.email ?? "",
    phone: providerInformation?.phone ?? "",
    homepage: providerInformation?.homepage ?? "",
    address: providerInformation?.address ?? null,
  };
}

export function normalizeTextValue(value) {
  return (value ?? "").trim();
}

export function getAddressText(address) {
  return address?.raw ?? address?.formatted ?? "";
}

export function getAddressSignature(address) {
  if (!address) {
    return "";
  }

  return JSON.stringify({
    city: address.city ?? "",
    formatted: address.formatted ?? "",
    postCode: address.postCode ?? "",
    raw: address.raw ?? "",
    route: address.route ?? "",
    state: address.state ?? "",
    streetNumber: address.streetNumber ?? "",
    suiteNumber: address.suiteNumber ?? "",
    suiteType: address.suiteType ?? "",
  });
}

export function getDisplayAddressText(address) {
  const addressText = normalizeTextValue(getAddressText(address));
  const suiteText = [address?.suiteType, address?.suiteNumber]
    .map(normalizeTextValue)
    .filter(Boolean)
    .join(" ");

  if (!suiteText) {return addressText;}
  if (!addressText) {return suiteText;}
  if (addressText.toLowerCase().includes(suiteText.toLowerCase())) {return addressText;}

  const [streetLine, ...rest] = addressText.split(",");
  if (!streetLine) {return `${addressText} ${suiteText}`.trim();}

  return [`${streetLine.trim()} ${suiteText}`, ...rest.map((part) => part.trim())].join(", ");
}

export function areProviderTypesEqual(current = [], initial = []) {
  return (
    current.length === initial.length &&
    current.every((item, index) => item?.id === initial[index]?.id)
  );
}
